import { createActionCreator } from "deox";

import { PageableBillingCycleSummary, PageableStatementInformation } from "../../../types/types";
// Due Charges Actions
export const dueChargesLoading = createActionCreator("dueChargesLoading");
export const failed = createActionCreator("failed");
export const moreDueChargesLoading = createActionCreator("moreDueChargesLoading");
export const dueChargesLoaded = createActionCreator(
  "dueChargesLoaded",
  (resolve) => (dueCharges: PageableBillingCycleSummary, pageIndex: number) => resolve(dueCharges, pageIndex)
);
export const moreDueChargesLoaded = createActionCreator(
  "moreDueChargesLoaded",
  (resolve) => (dueCharges: PageableBillingCycleSummary, pageIndex: number) => resolve(dueCharges, pageIndex)
);
// Statement Information Actions
export const statementInformationLoading = createActionCreator("statementInformationLoading");
export const moreStatementInformationLoading = createActionCreator("moreStatementInformationLoading");
export const statementInformationLoaded = createActionCreator(
  "statementInformationLoaded",
  (resolve) => (statementInformation: PageableStatementInformation, pageIndex: number) =>
    resolve(statementInformation, pageIndex)
);
export const moreStatementInformationLoaded = createActionCreator(
  "moreStatementInformationLoaded",
  (resolve) => (statementInformation: PageableStatementInformation, pageIndex: number) =>
    resolve(statementInformation, pageIndex)
);
